import React from 'react';
import { agentIcon } from '../../types/iconRegistry';
import StatusDot from '../../components/status/StatusDot';
import DataModeBadge from '../../components/feedback/DataModeBadge';

function AgentHeader({ agent, mode = 'sample', children }) {
  const AgentIcon = agentIcon(agent.icon);

  return (
    <header className="agent-header">
      <div className="agent-header-identity">
        <div className={`agent-avatar-lg agent-${agent.status}`}>
          <AgentIcon />
        </div>
        <div>
          <p className="eyebrow">{agent.role}</p>
          <h1>
            {agent.name} <DataModeBadge mode={mode} />
          </h1>
        </div>
        <span className="agent-status-pill">
          <StatusDot pulse={agent.status === 'running'} status={agent.status} />
          {agent.status}
        </span>
      </div>
      <div className="agent-header-slot">
        {children}
      </div>
    </header>
  );
}

export default AgentHeader;
